module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"doYouWantToLogOut":"Vil du logge ut?","youWillBeRedirected":"Du vil bli omdirigert til {0}","logOut":"Logg ut"},"en":{"doYouWantToLogOut":"Do you want to log out?","youWillBeRedirected":"You will be redirected to {0}","logOut":"Log out"}}')
  delete Component.options._Ctor
}
